import * as React from "react";
import { useEffect, useState } from "react";
import { MenuItem, TextField } from "@material-ui/core";
import { cloGet, ENDPOINTS } from "./api";

interface Props {
  label: string;
  value: string;
  onChange: (cloMerchantId: string) => void;
  excludeId?: number;
}

const MerchantPicker: React.FC<Props> = ({ label, value, onChange, excludeId }) => {
  const [search, setSearch] = useState("");
  const [options, setOptions] = useState<any[]>([]);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const res = await cloGet(ENDPOINTS.CLO_MERCHANTS, { page: 1, pageSize: 50, status: "active", search: search || undefined });
        setOptions((res.data || []).filter((m: any) => m.id !== excludeId));
      } catch {
        setOptions([]);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [search, excludeId]);

  return (
    <>
      <TextField fullWidth margin="dense" label={`Search ${label.toLowerCase()}`} value={search} onChange={(e) => setSearch(e.target.value)} />
      <TextField select fullWidth margin="dense" label={label} value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((m) => (
          <MenuItem key={m.id} value={String(m.id)}>
            {m.name}
            {m.partner_name ? " · CLO retailer" : ""}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

export default MerchantPicker;
